import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { useMergeRefs } from '@floating-ui/react';

import { Comp, getContainerStylingTransientProps } from '@redsift/design-system';
import { StyledDialogContentActions } from './styles';
import { DialogContentActionsProps } from './types';
import { useDialogContext } from '../dialog';

const COMPONENT_NAME = 'DialogContentActions';
const CLASSNAME = 'redsift-dialog-content-actions';

/**
 * The DialogContentActions component.
 */
export const DialogContentActions: Comp<DialogContentActionsProps, HTMLDivElement> = forwardRef((props, ref) => {
  const propsWithDefaults = {
    flexDirection: 'row' as const,
    ...props,
  };

  const { transientProps, otherProps } = getContainerStylingTransientProps(propsWithDefaults);

  const { children, className, ...forwardedProps } = otherProps;

  const { actionsRef, initialFocus } = useDialogContext();

  return (
    <StyledDialogContentActions
      {...forwardedProps}
      {...transientProps}
      className={classNames(DialogContentActions.className, className)}
      ref={useMergeRefs([ref, actionsRef])}
      tabIndex={initialFocus === 'actions' ? -1 : undefined}
    >
      {children}
    </StyledDialogContentActions>
  );
});
DialogContentActions.className = CLASSNAME;
DialogContentActions.displayName = COMPONENT_NAME;
